import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './PlatformSwitcher.module.scss'
import ExternalIcon from '../../assets/external.svg'

const CoderPad: React.FC = () => {
  const t = useIntl()
  return (
    <a
      className={styles.externalLink}
      target='_blank'
      href='https://codingame.com/work'
      rel='noreferrer'
    >
      <div className={styles.platformIntro}>
        {t.formatMessage({ id: 'platformSwitcher.companies' })}
      </div>
      <div className={styles.platformName}>
        <span>
          Coder
        </span><span style={{ color: '#CC4E40' }}>Pad</span>
        <ExternalIcon className={styles.icon} />
      </div>
    </a>
  )
}

export default CoderPad
